<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <br><br>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="12"
        lg="6"
      >
        <div v-if="!text">
          <canvas
            id="myChart19"
            width="250"
            height="80"
          />
        </div>
        <div
          v-else
        >
          {{ text }}
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="12"
        lg="6"
      >
        <v-row>
          <v-col
            v-if="valorAberto"
            id="valorAbertoId"
            class="text-right"
            cols="12"
            sm="10"
            md="10"
            lg="10"
            :style="styleObject"
          >
            {{ valorAberto }}
          </v-col>
          <v-col
            cols="12"
            sm="1"
            md="1"
            lg="1"
          >
            <router-link
              to="/contas-receber/valor-aberto"
              :style="styleObject"
            >
              <v-icon
                id="iconLinkDetalheAberto"
                class="text-left"
              >
                mdi-dots-vertical
              </v-icon>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ContasReceber from '../../../../services/contasreceber'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardValoAberto',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableGrafico: true,
      text: null,
      valorReceber: 0,
      valorAberto: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      montaGrafico: true,
      percenteExibicao: null,
      primeiroDia: '',
      ultimoDia: '',
      empresa: [],
      selectClientes: [],
      loading: false,
      error: null,
      styleObject: {
        color: localStorage.corPrimaria,
      },
    }),

    created () {
      eventEmit.$on('set-valores-aberto', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-valores-aberto', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.empresa = select
        this.selectClientes = selectClientes

        this.MontarGrafico()
      },

      async MontarGrafico () {
        this.loading = true

        this.valorAberto = null
        this.percenteExibicao = null

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await ContasReceber.showRelacaoAbertosRecebidos(this.primeiroDia, this.ultimoDia, this.empresa, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorAberto = resposta.data.valorAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const porcentagemAtiginda = resposta.data.porcentagemAtiginda.toFixed(2)
            const porcentagemRestante = porcentagemAtiginda === 0 ? 0 : (100 - porcentagemAtiginda).toFixed(2)

            this.percenteExibicao = porcentagemAtiginda.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart19').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [porcentagemAtiginda, porcentagemRestante],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                maintainAspectRatio: false,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.percenteExibicao,
                    color: '#000000',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores à receber aberto no período selecionado') {
            this.text = resposta.data.mg

            this.valorAberto = resposta.data.valorAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.percenteExibicao = resposta.data.porcentagemAtiginda.toFixed(2).toString().replace('.', ',') + '%'

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>
 @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart19 {
      width: 260px !important;
      height: 60px !important;
      margin: -3rem 0 0 -6rem;
    }

    #valorAbertoCR {
      margin: 0 0 0 4.3rem !important;
    }

    #valorAbertoId {
      font-size: 20px;
      display: grid;
      align-items: center;
      margin: -6.5rem 0 0 -4rem;
      font-weight: bold;
    }

    #iconLinkDetalheAberto {
      margin: -10rem 0 0 18rem !important;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart19 {
      width: 166px !important;
      height: 55px !important;
      margin: -4rem 0 0 0rem;
    }

    #valorAbertoCR {
      margin: 0 0 0 4.3rem !important;
    }

    #valorAbertoId {
      font-size: 20px;
      display: grid;
      align-items: center;
      margin: -7rem 0 0 10.7rem;
      font-weight: bold;
    }

    #iconLinkDetalheAberto {
      margin: -10rem 0 0 22.5rem !important;
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1800px) {
    #myChart19 {
      margin: -3rem 0 0 0rem;
      height: 51px !important;
      width: 136px !important;
    }

    #valorAbertoCR {
      font-size: 20px;
      margin: 0 0 0 5rem
    }

    #valorAbertoId {
      margin: -2.5rem 0 0 -1.5rem;
    }

    #iconLinkDetalheAberto {
      margin: -2.5rem 0 0 0rem
    }
  }

  @media screen
  and (min-width: 1801px) {
    #myChart19 {
      margin: -3rem 0 0 6rem;
      width: 195px !important;
      height: 50px !important;
    }

    #valorAbertoCR {
      font-size: 16px;
      margin: 0 0 0 9.5rem
    }

    #valorAbertoId {
      margin: -2.5rem 0 0 0rem;
    }

    #iconLinkDetalheAberto {
      margin: -2.5rem 0 0 -1rem
    }
  }
</style>

<style lang="sass">
  #myChart19
    margin: -3.5rem 0 0 0rem
    height: 51px !important
    width: 136px !important

  #valorAbertoCR
    margin: 0 0 0 2rem
    font-weight: bold

  #valorAbertoId
    font-size: 18px
    display: grid
    align-items: center
    margin: -3.5rem 0 0 -1.8rem
    font-weight: bold

  #carregaContasReceberAberto
    font-size: 12px

  #iconLinkDetalheAberto
    margin: -3.5rem 0 0 0.5rem
</style>
